/* istanbul ignore file */
import _ from 'lodash'
import { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import { Flex, Box } from 'rebass'
import { createSelector } from 'reselect'
import styled from 'styled-components'

import AcceptedDocument from 'assets/images/nav/AcceptedDocument.svg'
import AddDocument from 'assets/images/nav/AddDocument.svg'
import Stethoscope from 'assets/images/nav/Stethoscope.svg'
import { getAppConfig } from 'deploy-env/app-config'
import {
  saveDataAuraToMiddelware,
  setAppValue,
  setDefaultAppValue,
  updateHealthSession,
} from 'e-submission/apps/actions'
import { genaratedTransRefGUID, getCurrentAppId } from 'e-submission/apps/selectors'
import FormContent from 'e-submission/components/Layout/FormContent'
import FormSection from 'e-submission/components/Layout/FormSection'
import AuraValidation from 'e-submission/containers/AppForm/FormValidation/auraValidation'
import { IsRealDevice } from 'e-submission/utils'
import { getPredefineData } from 'e-submission/utils/tranformData'

const Aura = styled.div`
  width: 100%;
  text-align: center;
  img,
  svg {
    margin-bottom: 0.5rem;
  }
  iframe {
    width: 100%;
    height: 1024px;
  }
`

export const getFlagRiderHavePayer = (applicationInfo) => {
  const riderObj = _.get(applicationInfo, 'quickQuote.coveragePlan.riders')
  let flagRiderHavePayer = false
  const riderHavePayer = ['WPD01', 'WPDD01']
  const riderCodeHavePayer = ['PBPDD', 'PBPDDCI', 'PBSDD', 'PBSDDCI']
  if (!_.isEmpty(riderObj)) {
    for (var key in riderObj) {
      if (_.get(riderObj, `${key}.isSelectable`, false) && _.get(riderObj, `${key}.isSelected`)) {
        const riderName = _.get(riderObj, `${key}.name`, '')
        const riderCode = _.get(riderObj, `${key}.code`, '')
        flagRiderHavePayer =
          _.indexOf(riderHavePayer, riderName) >= 0 || _.indexOf(riderCodeHavePayer, riderCode) >= 0
            ? true
            : flagRiderHavePayer
      }
    }
  }
  return flagRiderHavePayer
}

const transformSessionIdPredefinedData = (predefinedData, auraHealthSession) => {
  return {
    ...predefinedData,
    party: _.compact([
      {
        ...predefinedData.party[0],
        sessionId: auraHealthSession?.sessionId,
        transRefGUID: auraHealthSession?.sessionId,
      },
      predefinedData?.party?.[1]
        ? {
            ...predefinedData.party[1],
            sessionId: auraHealthSession?.payerSessionId,
            transRefGUID: auraHealthSession?.payerSessionId,
          }
        : undefined,
    ]),
  }
}

const Component = (props) => {
  const { auraImpairment, insuredSessionId, predefineData } = props
  const iFrameURL = encodeURI(getAppConfig().AURA_INTEGATION_URL)
  const refAura = useRef()

  const [auraFrameRef, toSetAuraFrameRef] = useState(undefined)
  const [isPredefined, toSetIsPredefined] = useState(false)
  const [dataDefineData, setDataDefineData] = useState(undefined)

  const displayAura = () => {
    if (!IsRealDevice) {
      return (
        <div>
          <iframe
            ref={refAura}
            src={iFrameURL}
            onLoad={(event) => {
              if (!IsRealDevice) {
                //  NOTE: section postMessage wait after aura iframe render finish
                setTimeout(() => {
                  if (!refAura || !refAura.current) {
                    return
                  }
                  const payloadAura = {
                    event_id: 'predefineData',
                    value: dataDefineData,
                  }
                  refAura.current.contentWindow.postMessage(payloadAura, '*')
                }, 3000)
              }
            }}
            width="100%"
            frameBorder="0"
          />
        </div>
      )
    }

    return (
      <div>
        <FormSection>
          <FormContent>
            <Flex>
              <Box w={1}>ระบบการพิจารณารับประกันสุขภาพเบื้องต้น</Box>
            </Flex>
          </FormContent>
        </FormSection>
        <FormSection>
          <FormContent>
            <Flex>
              <Box w={1}>
                <Button
                  color="primary"
                  onClick={(e) => {
                    e.preventDefault()
                    const ref = window.cordova.InAppBrowser.open(
                      iFrameURL,
                      '_blank',
                      'location=no,disallowoverscroll=yes'
                    )
                    toSetAuraFrameRef(ref)
                  }}
                >
                  เข้าสู่ระบบ
                </Button>
              </Box>
            </Flex>
          </FormContent>
        </FormSection>
      </div>
    )
  }

  const displayCompleteMessage = () => {
    let objMessageConfirm = null

    switch (auraImpairment) {
      case 'ACC':
        objMessageConfirm = (
          <FormContent>
            <img src={AcceptedDocument} alt="img-nav" />
            <FormContent>
              ขอแสดงความยินดีที่ท่านได้ทำการตอบแบบสอบถามเสร็จเรียบร้อย บริษัทฯ ขอเรียนให้ท่านทราบว่า
              การสมัครขอทำประกันของท่านในครั้งนี้
              ได้ผ่านการพิจารณารับประกันโดยระบบการพิจารณารับประกันของบริษัทภายใต้ข้อมูลสุขภาพที่ท่านได้แถลงไว้ในครั้งนี้เป็นที่เรียบร้อยแล้ว
              <br />
              <br />
              ขอขอบคุณท่านเป็นอย่างสูงที่ได้ให้ความไว้วางใจในการสมัครทำประกันชีวิตกับ บริษัท กรุงไทย-แอกซ่า ประกันชีวิต
              จำกัด (มหาชน)
              <br />
              <br />
              <br />
              หมายเหตุ : การตอบรับครั้งนี้ เป็นเพียงการตอบรับการสมัครขอทำประกันชีวิตกับบริษัท กรุงไทย-แอกซ่า ประกันชีวิต
              จำกัด (มหาชน) เท่านั้น ความคุ้มครองตามสัญญาประกันภัยจะเริ่มต้นเมื่อบริษัท ฯ
              ได้รับชำระเบี้ยประกันภัยและตกลงรับประกันอย่างเป็นทางการแล้วเท่านั้น
            </FormContent>
          </FormContent>
        )
        break
      case 'RUW':
        objMessageConfirm = (
          <FormContent>
            <img src={Stethoscope} alt="img-nav" />
            <FormContent>
              ขอบคุณที่ท่านได้ให้ความไว้วางใจเลือกสมัครทำประกันชีวิตกับบริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)
              บริษัท ฯ ได้รับใบคำขอเอาประกันภัยของท่านและนำส่งให้แผนกพิจารณารับประกันเป็นที่เรียบร้อยแล้ว
              <br />
              <br />
              ทั้งนี้ ขอเรียนให้ท่านทราบเพิ่มเติมว่า ท่านอาจได้รับการติดต่อจากบริษัท ฯ
              อีกครั้งเพื่อขอข้อมูลเพิ่มเติมสำหรับประกอบการพิจารณารับประกันภัยของท่านในครั้งนี้
            </FormContent>
          </FormContent>
        )
        break
      case 'EVR':
        objMessageConfirm = (
          <FormContent>
            <img src={AddDocument} alt="img-nav" />
            <FormContent>
              ขอบคุณที่ท่านได้ให้ความไว้วางใจเลือกสมัครทำประกันชีวิตกับบริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)
              บริษัท ฯ ได้รับใบคำขอเอาประกันภัยของท่านและนำส่งให้แผนกพิจารณารับประกันเป็นที่เรียบร้อยแล้ว
              เพื่อให้ท่านได้รับการพิจารณารับประกันโดยเร็วยิ่งขึ้น บริษัท ฯ
              ใคร่ขอความอนุเคราะห์ให้ท่านนำส่งเอกสารเพิ่มเติมประกอบการพิจารณา
              <br />
              <br />
              ทั้งนี้ ขอเรียนให้ท่านทราบเพิ่มเติมว่า ท่านอาจได้รับการติดต่อจากบริษัท ฯ
              อีกครั้งเพื่อขอข้อมูลเพิ่มเติมสำหรับประกอบการพิจารณารับประกันภัยของท่านในครั้งนี้
            </FormContent>
          </FormContent>
        )
        break
      default:
        objMessageConfirm = (
          <FormContent>
            <img src={AddDocument} alt="img-nav" />
            <FormContent>
              ขอบคุณที่ท่านได้ให้ความไว้วางใจเลือกสมัครทำประกันชีวิตกับบริษัท กรุงไทย-แอกซ่า ประกันชีวิต จำกัด (มหาชน)
              บริษัท ฯ ได้รับใบคำขอเอาประกันภัยของท่านและนำส่งให้แผนกพิจารณารับประกันเป็นที่เรียบร้อยแล้ว
              เพื่อให้ท่านได้รับการพิจารณารับประกันโดยเร็วยิ่งขึ้น บริษัท ฯ
              ใคร่ขอความอนุเคราะห์ให้ท่านนำส่งเอกสารเพิ่มเติมประกอบการพิจารณา
              <br />
              <br />
              ทั้งนี้ ขอเรียนให้ท่านทราบเพิ่มเติมว่า ท่านอาจได้รับการติดต่อจากบริษัท ฯ
              อีกครั้งเพื่อขอข้อมูลเพิ่มเติมสำหรับประกอบการพิจารณารับประกันภัยของท่านในครั้งนี้
            </FormContent>
          </FormContent>
        )
    }

    return (
      <FormSection>
        <FormContent>{objMessageConfirm}</FormContent>
      </FormSection>
    )
  }

  useEffect(() => {
    if (dataDefineData) {
      setDataDefineData(predefineData)
    }
    const frame = document.getElementsByTagName('iframe')[0] || undefined
    window.addEventListener('message', (event) => {
      if (event.data.event_id === 'submitAura') {
        props.saveDataAura(event.data?.value)
      }

      // NOTE: Handle case session id not match
      if (event.data.event_id === 'updateSessionId') {
        const auraHealthSession = event.data?.value
        // NOTE: For update session id from api aura cs
        props.updateSessionIdFromAura(auraHealthSession)

        const transformedPredefineData = transformSessionIdPredefinedData(predefineData, auraHealthSession)
        // NOTE: Predefined Data for web
        frame?.contentWindow.postMessage(
          {
            event_id: 'predefineData',
            value: transformedPredefineData,
          },
          '*'
        )
      }
    })
  }, [])
  useEffect(() => {
    if (!insuredSessionId && !auraImpairment) {
      const date = new Date()
      const sessionId = genaratedTransRefGUID('insured')
      const payerSessionId = genaratedTransRefGUID('payer')

      let healthSession = {
        sessionId,
        updateAt: date,
        updateBy: 'AdvisorZone',
      }

      if (!props.payerSessionId && props.hasPayerSession) {
        healthSession = {
          ...healthSession,
          payerSessionId,
          payerUpdateAt: date,
        }
      }

      props.setHealthSession(healthSession)

      // TODO: Remove this log after solved
      const logHealthSession = _.compact([
        props?.logHealthSession ? props.logHealthSession : undefined,
        {
          sessionId,
          createAt: date,
          createBy: 'AdvisorZone',
          ...(props?.hasPayerSession && { payerSessionId }),
          ...(props?.hasPayerSession && { payerCreateAt: date }),
        },
      ])
      props.setLogHealthSession(logHealthSession)
    }
  }, [insuredSessionId, auraImpairment])
  useEffect(() => {
    if (!IsRealDevice && (!dataDefineData || !_.isEqual(predefineData, dataDefineData))) {
      setDataDefineData(predefineData)
    }
  }, [predefineData, dataDefineData, setDataDefineData])

  useEffect(() => {
    if (!auraFrameRef) {
      console.log('Aura frame ref is not available')
      return
    }

    const auraPage = auraFrameRef
    let loop, loop2

    const sendPredefineData = (auraPageRef, transformedData) => {
      auraPageRef.executeScript({
        code: `window.postMessage(${JSON.stringify({
          event_id: 'predefineData',
          value: { ...transformedData, isMobile: true },
        })}, '*');`,
      })
    }

    const auraInterval = async (refPage) => {
      const iabResolveExecuteScript = (code) =>
        new Promise((resolve) => {
          refPage.executeScript({ code }, (value) => resolve(value))
        })

      refPage.executeScript({ code: 'document.getElementById("aura-length")?.value' }, async (value) => {
        if (!_.isEmpty(value) && !_.isNil(value[0])) {
          const dataLength = JSON.parse(value)
          let auraData = ''

          for (let i = 0; i < dataLength; i++) {
            const val = await iabResolveExecuteScript(`document?.getElementById("aura-result-${i}")?.value`)
            if (!_.isEmpty(val) && !_.isNil(val[0])) {
              auraData += val[0]
            }
            if (i === dataLength - 1) {
              const auraResult = JSON.parse(auraData)
              props.saveDataAura(auraResult.value)
              auraPage.close()
              clearInterval(loop)
              loop = 'stop loop'
            }
          }
        }
      })
    }

    const sessionIdNotMatchInterval = (refPage) => {
      refPage.executeScript({ code: 'document.getElementById("aura-interview-status")?.value' }, async (value) => {
        if (!_.isEmpty(value[0]) && !_.isNil(value[0])) {
          const auraHealthSession = JSON.parse(value)
          props.updateSessionIdFromAura(auraHealthSession)

          const transformedPredefineData = transformSessionIdPredefinedData(predefineData, auraHealthSession)
          sendPredefineData(auraPage, transformedPredefineData)
        }
      })
    }

    const loadstopHandler = () => {
      try {
        if (isPredefined === false) {
          toSetIsPredefined(true)
          setTimeout(() => sendPredefineData(auraPage, predefineData), 3000)
        }
        if (!loop) loop = setInterval(auraInterval, 5000, auraPage)
        if (!loop2) loop2 = setInterval(sessionIdNotMatchInterval, 7000, auraPage)
      } catch (e) {
        clearInterval(loop)
        clearInterval(loop2)
        loop = 'stop loop'
        loop2 = 'stop loop'
      }
    }

    const exitHandler = () => {
      toSetIsPredefined(false)
      clearInterval(loop)
      clearInterval(loop2)
      loop = 'stop loop'
      loop2 = 'stop loop'
    }

    auraPage.addEventListener('loadstop', loadstopHandler)
    auraPage.addEventListener('exit', exitHandler)

    return () => {
      auraPage.removeEventListener('loadstop', loadstopHandler)
      auraPage.removeEventListener('exit', exitHandler)
      clearInterval(loop)
      clearInterval(loop2)
    }
  }, [auraFrameRef])
  return (
    <Aura className="aura-container">
      <AuraValidation />
      {!auraImpairment ? displayAura() : displayCompleteMessage()}
    </Aura>
  )
}

// Memoized selector to prevent unnecessary re-creation of predefineData
const getPredefineDataSelector = createSelector(
  [
    (state, ownProps) => {
      const currentAppId = getCurrentAppId(state)
      const currentData = _.get(state, `apps.byId.${currentAppId}`, {})
      const insuredPayer = _.get(currentData, 'quickQuote.insured.payer', {})
      const isPayerNeeded = _.get(currentData, 'quickQuote.insured.payerNeeded', '')
      const flagRiderHavePayer = getFlagRiderHavePayer(currentData)
      const hasPayerSession = flagRiderHavePayer && isPayerNeeded && insuredPayer
      const insuredSessionId = _.get(currentData, 'healthSession.sessionId', '')
      const payerSessionId = _.get(currentData, 'healthSession.payerSessionId', '')
      const accessToken = _.get(ownProps, 'access_token')

      // Create a stable key for memoization that excludes timestamp-dependent data
      return {
        currentData: _.omit(currentData, ['_updatedAt', '_createdAt']), // Exclude timestamp fields that change frequently
        insuredSessionId,
        payerSessionId,
        hasPayerSession,
        accessToken,
      }
    },
  ],
  ({ currentData, insuredSessionId, payerSessionId, hasPayerSession, accessToken }) => {
    return getPredefineData(currentData, insuredSessionId, payerSessionId, hasPayerSession, accessToken)
  }
)

const mapStateToProps = (state, ownProps) => {
  const currentAppId = getCurrentAppId(state)
  const currentData = _.get(state, `apps.byId.${currentAppId}`, {})

  const insuredPayer = _.get(currentData, 'quickQuote.insured.payer', {})
  const isPayerNeeded = _.get(currentData, 'quickQuote.insured.payerNeeded', '')
  const flagRiderHavePayer = getFlagRiderHavePayer(currentData)
  const hasPayerSession = flagRiderHavePayer && isPayerNeeded && insuredPayer

  const insuredSessionId = _.get(currentData, 'healthSession.sessionId', '')
  const payerSessionId = _.get(currentData, 'healthSession.payerSessionId', '')
  const accessToken = _.get(ownProps, 'access_token')

  return {
    insuredSessionId,
    payerSessionId,
    hasPayerSession,
    predefineData: getPredefineDataSelector(state, ownProps),
  }
}

const mapDispatchToProps = (dispatch) => ({
  saveDataAura: (auraOutput) => {
    dispatch(saveDataAuraToMiddelware(auraOutput))
  },
  setHealthSession: (session) => {
    dispatch(setDefaultAppValue('healthSession', session))
  },
  setLogHealthSession: (session) => {
    dispatch(setAppValue('logHealthSession', session))
  },
  updateSessionIdFromAura: (value) => {
    dispatch(updateHealthSession(value))
  },
})

export default (hoc) => connect(mapStateToProps, mapDispatchToProps)(Component)
